<template>
  <div>
    <Table border :columns="columns1" :data="data1"></Table>
    <br />
    <Page :total="total" show-total @on-change="changePage" @on-page-size-change="changePagesize" />
  </div>
</template>
<script>
export default {
  props: {
    workId: {
      type: String,
      value: '',
    },
  },
  data() {
    return {
      columns1: [
      {
          title: '维修记录提交时间',
          minWidth: 170,
          align: 'left',
          key: 'trackTime',
        },
        {
          title: '维修人',
          minWidth: 150,
          key: 'maintainerName',
          align: 'left',
          copy: true,
        },
        {
          title: '维修照片',
          key: 'imgUrl',
          minWidth: 250,
          align: 'center',
          lign: 'left',
          render:(h,params)=>{
              let imgArr=[];
              let dom = null
              dom =  h('div',[
                // 插入多张图片
                params.row.imgUrl.split(",").forEach(url => {
                  imgArr.push(h('img',{
                      attrs:{
                        src:url
                      },
                      style:{
                        width:'100px',
                        height:'200px',
                      }
                  }));
                }),
                h('span',{

                  },imgArr)
              ])
              return dom}
        },
        {
          title: '维修内容',
          minWidth: 120,
          align: 'center',
          key: 'maintainerContent',
        },
        {
          title: '备注',
          minWidth: 90,
          key: 'remark',
          align: 'center',
        },
       
    
      ],
      data1: [],
      total:this.total,
    }
  },
  created() {
  },
  mounted() {
    if (this.workId) {
      this.load(this.workId)
    }
  },
  methods: {
    load(workId,page=1, ) {
      let q = {}
      // let a = {}
      // a.workId = workId
      q.workId = workId
      // q.page = page
      q.pageSize = 10
      q.pageNum = page
      $utils.api
        .load('/admin/system/track/list', q)
        .then((res) => {
          if (res.code > 0) {
            let data = res.rows
            let list = data || []
            this.data1 = list
            this.total = res.total
          }
        })
        .catch(() => {
          $utils.toast.error('请求错误')
        })
    },
    changePage(p) {
      this.load(this.workId, p)
    },
    changePagesize(psize) {
    },
  },
}
</script>
